<template>
<div class="bg-white">
    <div class="container">
        <div class="row">
            <div class="col">
                <div>
                    <h1 class="font-weight-bold mt-5 mb-5 headline-strong-1 text-blue">Allgemeine Geschäfts&shy;bedingungen für Leistungen (AGB) der
                        GSI – Gesellschaft für Schweisstechnik International mbH</h1>
                    <div>
                        <ul style="list-style:decimal">
                            <li class="font-weight-bold mt-2">Geltung dieser Bedingungen
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Arten von
                                        vertraglichen und vorvertraglichen Beziehungen gegenüber Unternehmen,
                                        Kaufleuten, juristischen Personen des öffentlichen Rechts oder einem öffentlich
                                        rechtlichem Sondervermögen – nachfolgend auch Auftraggeber oder Kunden genannt –
                                        , gleichgültig ob es sich um die Erfüllung von Haupt- oder Nebenpflichten
                                        handelt. Sie gelten gegenüber unseren Kunden auch für alle zukünftigen
                                        Geschäftsbeziehungen.</li>
                                    <li>Diese AGB gelten nachrangig gegenüber eventuell abweichenden oder ergänzenden
                                        Regelungen in unseren schriftlichen Vertragsangeboten und/oder den von uns
                                        eigenhändig
                                        erstellten schriftlichen Auftragsbestätigungen (siehe
                                        hierzu auch Ziffer 1.3). Nicht anzuwenden sind diese AGB auf Leistungen, die die
                                        „Ausbildung
                                        und Prüfung von Schweißern, die Durchführung von Lehrveranstaltungen, oder die
                                        sonstige
                                        Prüfung von Personen betreffen. Für diese
                                        Ausbildungs- und Prüfungsleistungen gelten unsere „besonderen
                                        Teilnahmebedingungen“.</li>
                                    <li>Abweichende, zusätzliche oder entgegenstehende Bedingungen des Kunden gelten
                                        nicht,
                                        selbst wenn der Kunde in seiner Bestellung oder in seiner Angebotsanfrage auf
                                        die alleinige
                                        Anwendung seiner AGB verweist. Abweichende,
                                        zusätzliche oder entgegenstehende AGB unserer Kunden gelten auch dann nicht,
                                        wenn wir in
                                        Kenntnis dieser Bedingungen dem Kunden ein seiner Bestellung beiliegendes
                                        vorformuliertes
                                        Bestätigungsschreiben zusenden oder wir in
                                        Kenntnis abweichender oder ergänzender Bedingungen unsere Leistung vorbehaltlos
                                        ausführen.
                                        Die AGB unserer Kunden gelten nur, wenn sie ausdrücklich durch eigenhändige
                                        schriftliche
                                        Erklärung, oder mündliche Erklärung der
                                        vertretungsberechtigten Organe der GSI, unserer Handlungsbevollmächtigten oder
                                        von
                                        Mitarbeitern mit schriftlicher Einzelvollmacht anerkannt werden.</li>
                                </ul>
                            </li>
                            <li class="font-weight-bold mt-2">Vertragsschluss
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Ein Vertrag mit uns gilt als geschlossen, wenn der Kunde unser Angebot mündlich,
                                        schriftlich, per Fax oder e-Mail annimmt, dem Kunden auf seine Bestellung unsere
                                        schriftliche Auftragsbestätigung zugeht oder wir mit der
                                        Ausführung der Leistung beginnen. Nehmen wir ein Angebot zum Abschluss eines
                                        Vertrages (z.B.
                                        eine Bestellung unseres Kunden) an, ist unsere Auftragsbestätigung für Inhalt
                                        und Umfang des
                                        Vertrages maßgeblich, sofern nicht
                                        ausdrücklich etwas anderes vereinbart ist.</li>
                                    <li>Mündliche Nebenabreden, Zusagen und sonstige mündliche Vereinbarungen
                                        verpflichten uns
                                        nur, wenn sie durch vertretungsberechtigte Organe der GSI,
                                        Handlungsbevollmächtigte oder
                                        Mitarbeiter mit schriftlicher Einzelvollmacht
                                        abgegeben werden.</li>

                                </ul>
                            </li>
                            <li class="font-weight-bold mt-2">Auftragsdurchführung und Mitwirkungspflichten des Kunden
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Soweit nicht ausdrücklich etwas anderes vereinbart wurde, schulden wir nur die
                                        vertraglich genau festgelegten Leistungen, die wir unter Beachtung der allgemein
                                        anerkannten
                                        Regeln der Technik und der gesetzlichen Vorgaben
                                        erbringen. Unsere Sachverständigen und fachkundigen Personen sind bei der
                                        Durchführung von
                                        Prüf- und Gutachteraufträgen weisungsunabhängig.</li>
                                    <li>Für Beschädigungen oder Zerstörungen von Gegenständen des Kunden als Folge einer
                                        sachgerechten Durchführung unserer Leistung leisten wir keinen Ersatz. Wird als
                                        Folge einer
                                        sachgerechten Durchführung unserer Leistung ohne
                                        unser Verschulden unser eigenes Gerät beschädigt oder zerstört oder kommt
                                        abhanden, so sind
                                        wir berechtigt, vom Kunden in entsprechender Anwendung von § 670 BGB Wertersatz
                                        zu
                                        verlangen. Der Transport und gegebenenfalls der
                                        Rücktransport von Gegenständen des Kunden erfolgt auf seine Kosten und Gefahr,
                                        der
                                        Rücktransport wird jedoch nur auf ausdrückliches Verlangen des Kunden
                                        durchgeführt. Bei der
                                        Aufbewahrung ist unsere Haftung auf die
                                        eigenübliche Sorgfalt beschränkt.</li>
                                    <li>Der Kunde hat uns alle für die Durchführung unserer Leistung relevanten
                                        Tatsachen
                                        vollständig zur Kenntnis zu geben. Wir sind nicht verpflichtet, vom Kunden zur
                                        Verfügung
                                        gestellte Daten, Informationen oder sonstige
                                        Leistungen auf ihre Vollständigkeit und Richtigkeit zu überprüfen, soweit hierzu
                                        unter
                                        Berücksichtigung der jeweiligen Umstände des Einzelfalls kein Anlass besteht.
                                    </li>
                                    <li>Soweit zur Durchführung unserer Leistung ein- oder mehrmalige
                                        Mitwirkungshandlungen des
                                        Kunden erforderlich sind, hat er diese auf unser Verlangen hin auf eigene Kosten
                                        zu
                                        erbringen; Aufwendungen werden ihm nur erstattet,
                                        wenn dies ausdrücklich vereinbart wurde. Sofern er seinen Mitwirkungspflichten
                                        trotz
                                        schriftlicher Aufforderung unter Hinweis auf die Regelung dieser Bestimmung
                                        (Ziffer 3.4 Satz
                                        2 AGB) nicht, nicht rechtzeitig oder nicht
                                        ordnungsgemäß nachkommt, sind wir berechtigt, ihm den dadurch entstehenden
                                        Mehraufwand in
                                        Rechnung zu stellen. Weitergehende gesetzliche Ansprüche bleiben ausdrücklich
                                        vorbehalten.</li>
                                    <li>Werden wir außerhalb unseres Betriebsgeländes tätig, so obliegen dem Kunden alle
                                        zur
                                        Erfüllung von Verkehrssicherungspflichten notwendigen Maßnahmen, soweit sich
                                        nicht aus der
                                        Natur der Sache oder einer Vereinbarung mit
                                        dem Kunden etwas anderes ergibt. Wir sind berechtigt, die Durchführung der
                                        Leistung zu
                                        verweigern, solange die notwendigen Maßnahmen nicht getroffen werden. Zu den
                                        notwendigen
                                        Maßnahmen zählt auch die Verpflichtung des Kunden
                                        die Erfüllungs- und Verrichtungsgehilfen der GSI bei der Beurteilung und
                                        Beseitigung
                                        möglicher Gefährdungen, die bei der Leistungserbringung außerhalb unseres
                                        Betriebsgeländes
                                        entstehen können, nach den Vorschriften des
                                        Arbeitsschutzgesetztes und nach den bei der Arbeit zu beachtenden
                                        Unfallverhütungsvorschriften des gesetzlichen Unfallversicherungsträgers zu
                                        unterstützen.
                                        Evtl. sich daraus ergebene Wartezeiten werden wie Arbeitszeit
                                        berechnet.</li>
                                    <li>Wird GSI mit der Erstellung eines Qualitätssicherheitsberichtes (nachfolgend
                                        QSBericht)
                                        beauftragt, so darf dieser QS-Bericht seitens des Kunden nur ungekürzt bzw.
                                        unbearbeitet an
                                        Dritte weitergegeben werden. Eine
                                        gekürzte oder sonst wie bearbeitete Weitergabe des QS-Berichtes an Dritte ist
                                        nur dann
                                        zulässig, wenn eine vorherige schriftliche (auch per Fax oder e-Mail) Zustimmung
                                        seitens GSI
                                        oder der beauftragten Niederlassung vorliegt.
                                        Wird ein gekürzter oder sonst wie bearbeiteter QS-Bericht seitens des Kunden
                                        unberechtigt
                                        weitergegeben, dann entfällt eine Haftung seitens GSI für den Inhalt dieses
                                        Berichtes.</li>
                                    <li>Liefert der Kunde verstrahltes oder sonst wie gesundheitsgefährdendes Material
                                        bei GSI
                                        an, dann ist der Kunde verpflichtet, dieses angelieferte Material unverzüglich
                                        auf seine
                                        eigenen Kosten bei GSI abzuholen. Kommt der
                                        Kunde der Aufforderung seitens GSI nicht innerhalb von 48 Stunden nach, ist GSI
                                        berechtigt,
                                        das Material auf Kosten des Kunden an diesen zurückzusenden oder anderweitig zu
                                        entsorgen.</li>
                                    <li>Werden der GSI bei der Durchführung eines Auftrages Proben zur Auswertung oder
                                        Untersuchung seitens des Kunden zur Verfügung gestellt, so werden diese, sofern
                                        nicht
                                        gesondert vereinbart, nach Beendigung des Auftrags
                                        vernichtet.</li>

                                </ul>
                            </li>
                            <li class="font-weight-bold mt-2">Fristen, Termine, Verzug und Unmöglichkeit
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Fristen und Termine gelten stets als unverbindlich, sofern sie nicht in unserem
                                        Angebot
                                        oder in unserer Auftragsbestätigung ausdrücklich als „verbindlich““ bezeichnet
                                        sind. Soweit
                                        sie unverbindlich sind, geraten wir erst
                                        dann in Verzug, wenn der Kunde uns zuvor ergebnislos eine angemessene Frist zur
                                        Erbringung
                                        der geschuldeten Leistung schriftlich gesetzt hat. In jedem Fall laufen Fristen
                                        erst ab der
                                        vollständigen Erbringung sämtlicher vom
                                        Kunden geschuldeter Mitwirkungshandlungen sowie gegebenenfalls ab Eingang einer
                                        vereinbarten
                                        Anzahlung. Nachträgliche Änderungswünsche oder verspätet erbrachte
                                        Mitwirkungshandlungen des
                                        Kunden verlängern die Leistungszeiten
                                        angemessen.</li>
                                    <li>Leistungsverzögerungen, die wir nicht zu vertreten haben, z.B. aufgrund höherer
                                        Gewalt,
                                        Arbeitskampf oder aufgrund ähnlicher Ereignisse, die uns die Leistung
                                        vorübergehend
                                        wesentlich erschweren oder unmöglich machen, ver-
                                        längern die Leistungsfrist um die Dauer der Störung zuzüglich einer angemessenen
                                        Anlauffrist. Verlängert sich die Leistungszeit durch solche Umstände, so kann
                                        der Kunde
                                        hieraus keine Schadensersatzansprüche herleiten. Die
                                        vorstehenden Regelungen (in Ziffer 4.2) gelten auch, wenn die Störung bei
                                        unseren
                                        Lieferanten oder deren Unterlieferanten eintritt.</li>
                                    <li>Kommt der Kunde in Annahmeverzug oder verletzt er sonstige Mitwirkungspflichten,
                                        so
                                        sind wir berechtigt, nach erfolgloser Fristsetzung den uns entstehenden Schaden
                                        einschließlich etwaiger Mehraufwendungen zu
                                        verlangen.</li>
                                    <li>Geraten wir aus Gründen, die wir zu vertreten haben in Verzug, oder wird die
                                        Leistung
                                        aus von uns zu vertretenden Gründen unmöglich, so ist unsere
                                        Schadensersatzpflicht im Fall
                                        leichter Fahrlässigkeit auf den nach Art des
                                        Auftrages vorhersehbaren, vertragstypischen, unmittelbaren Durchschnittsschaden
                                        begrenzt.</li>

                                </ul>
                            </li>
                            <li class="font-weight-bold mt-2">Abnahme
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Soweit unsere Leistung der Abnahme bedarf, ist der Kunde hierzu verpflichtet.
                                        Kleinere
                                        Mängel, welche die Tauglichkeit der Leistung zu dem vertraglich festgelegten
                                        Zweck nicht
                                        wesentlich beeinträchtigen, berechtigen den
                                        Kunden nicht, die Abnahme zu verweigern, unbeschadet seines Rechts, die
                                        Beseitigung dieser
                                        Mängel innerhalb einer angemessenen Frist zu verlangen.</li>
                                    <li>Nimmt der Kunde die Leistung oder einen Teil der Leistung in Benutzung, so gilt
                                        die
                                        Abnahme nach Ablauf von zehn Werktagen nach Beginn der Nutzung als erfolgt, wenn
                                        nichts
                                        anderes vereinbart ist. Auf diese Folge werden
                                        wir den Kunden bei Beginn der Frist ausdrücklich hinweisen.</li>
                                    <li>Geistige Leistungen gelten als abgenommen, sofern der Kunde nicht innerhalb von
                                        30
                                        Tagen nach deren Zugang in schriftlicher Form ausdrücklich schriftlich
                                        Vorbehalte erhebt.
                                        Auf diese Folge werden wir bei Übergabe der
                                        Leistung ausdrücklich hinweisen. Im Fall eines solchen Vorbehalts werden wir
                                        unsere Leistung
                                        überprüfen. Erweist sich ein Vorbehalt des Kunden als unberechtigt, fallen ihm
                                        die
                                        entstandenen Mehrkosten zur Last.</li>


                                </ul>
                            </li>
                            <li class="font-weight-bold mt-2">Gebühren/ Preise und Zahlung
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Maßgeblich sind die Gebühren gemäß unseres(r) zum Zeitpunkt des
                                        Vertragsabschlusses
                                        gültigen Gebührenverzeichnisse(s) bzw. die unseres Angebotes, zu denen die
                                        jeweils gültige
                                        gesetzliche Mehrwertsteuer – soweit diese
                                        anfällt – hinzugerechnet wird. Unsere Rechnungen sind ohne Skontoabzug und
                                        spesenfrei,
                                        gegebenenfalls nach vereinbartem Zahlungsplan, ansonsten innerhalb von 14 Tagen
                                        ab
                                        Rechnungsdatum zur Zahlung fällig. Schecks erkennen wir
                                        erst dann als Erfüllung an, wenn die jeweiligen Beträge auf unserem Konto
                                        gutgeschrieben
                                        worden sind. Wir behalten uns das Recht vor, angemessene Abschlagszahlungen und
                                        Vorschüsse
                                        zu verlangen.</li>
                                    <li>Sofern kein Festpreis vereinbart wurde und sich bei der Durchführung einer
                                        Leistung
                                        herausstellt, dass die Kosten den gegenüber dem Kunden insgesamt veranschlagten
                                        Betrag um
                                        mehr als 20 % überschreiten, werden wir ihm
                                        dies unverzüglich mitteilen. Der Kunde ist in diesem Fall zur Kündigung des
                                        Vertrages
                                        berechtigt. Wir rechnen dann nur die bis zu diesem Zeitpunkt von uns erbrachten
                                        Leistungen,
                                        sowie die in der Vergütung nicht inbegriffenen
                                        Auslagen ab. Gleiches gilt, wenn wir aus wichtigem Grund von dem Vertrag
                                        zurücktreten oder
                                        dieser einvernehmlich aufgehoben wird.</li>
                                    <li>Aufrechnungsrechte stehen dem Kunden nur zu, wenn seine Gegenansprüche
                                        rechtskräftig
                                        festgestellt, unbestritten oder von uns schriftlich anerkannt sind. Das gleiche
                                        gilt
                                        gegenüber Kaufleuten für die Geltendmachung von
                                        Zurückbehaltungsrechten.</li>
                                    <li>Werden uns nach Abschluss des Vertrages Umstände bekannt, welche die
                                        Kreditwürdigkeit
                                        des Kunden erheblich zu mindern geeignet sind, so sind wir berechtigt, noch
                                        ausstehende
                                        Leistungen nur gegen Vorauszahlung oder
                                        Sicherheitsleistung auszuführen und nach fruchtlosem Ablauf einer hierfür
                                        gesetzten Frist
                                        vom Vertrag zurückzutreten; Ziffer 2 Satz 3 dieses Abschnitts gilt entsprechend.
                                    </li>
                                    <li>Bei Zahlungsverzug schuldet der Kunde Verzugszinsen in Höhe von 5 Prozentpunkten
                                        über
                                        dem jeweiligen Basiszinssatz , sofern er Verbraucher ist und sofern er
                                        Unternehmer ist 9
                                        Prozentpunkte über dem jeweiligen
                                        Basiszinssatz. Die Geltendmachung eines höheren Schadens ist nicht
                                        ausgeschlossen.</li>
                                    <li>Mehrere Auftraggeber haften als Gesamtschuldner.</li>

                                </ul>
                            </li>
                            <li class="font-weight-bold mt-2">Gewährleistung/ Garantie
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Die Gewährleistung der GSI erstreckt sich auf die Anwendung wissenschaftlicher
                                        Sorgfalt
                                        sowie auf die Einhaltung der anerkannten Regeln der Technik, denen auch zur Zeit
                                        der Abnahme
                                        die von ihr erbrachten Leistungen zu
                                        entsprechen haben. Sie übernimmt bei Forschungs- und Entwicklungsaufträgen keine
                                        Gewähr für
                                        das tatsächliche Erreichen des angestrebten Vertragszieles in der geplanten
                                        Zeit.</li>
                                    <li>Wurden spezielle Qualitätsparameter/Eigenschaften von uns ausdrücklich
                                        zugesichert,
                                        garantieren wir deren Einhaltung zum Zeitpunkt der Abnahme bzw. dem
                                        Gefahrübergang unter der
                                        Bedingung der strengsten Beachtung der von
                                        uns gegebenen Hinweise durch den Auftraggeber. Die Zusicherung von
                                        Qualitätsparametern oder
                                        Eigenschaften erstreckt sich grundsätzlich nicht darauf, ob das Ergebnis unserer
                                        Leistung
                                        für den Auftraggeber zu dem von ihm
                                        beabsichtigten Zweck verwendbar ist. Dies gilt insbesondere für die
                                        Vermarktungsfähigkeit
                                        und die Nutzbarkeit der Erzeugnisse, die auf Basis des von uns gelieferten
                                        Ergebnisses
                                        produziert und angeboten werden.</li>
                                    <li>Die Erteilung eines Prüfzertifikats enthält keine über den konkreten technischen
                                        Inhalt
                                        des Prüfzeugnisses hinausgehende Aussage über die Verwendungsfähigkeit oder
                                        Qualität des
                                        Prüfgegenstandes. Es enthält insbesondere
                                        keine Zusicherung oder Garantie über spezielle Eigenschaften des Produktes. Es
                                        besagt
                                        grundsätzlich nur, dass wir bei Anwendung der vertraglich vereinbarten
                                        Prüfspezifikation
                                        bzw. Prüfnorm, keine unzulässigen Abweichungen zu
                                        den in der jeweiligen Norm festgelegten (Richt-) Werten festgestellt haben.</li>
                                    <li>Wir gewährleisten nicht für solche Mängel, die ihre Ursache im Handeln des
                                        Auftraggebers haben oder bei der Abnahme dem Auftraggeber bekannt waren und erst
                                        danach
                                        geltend gemacht werden.</li>
                                    <li>Sollten wir eine fehlerhafte Leistung erbracht haben, hat uns der Kunde
                                        Gelegenheit zur
                                        Nacherfüllung innerhalb angemessener Fristen zu geben. Schlägt die Nacherfüllung
                                        fehl, kann
                                        der Kunde nach seiner Wahl nur
                                        Herabsetzung der Vergütung (Minderung) oder Rückgängigmachung des Vertrages
                                        (Rücktritt) und
                                        Schadensersatz im Rahmen der Haftungsbeschränkung (Ziffer 8 AGB) statt der
                                        Leistung
                                        verlangen. Bei einer nur geringfügigen
                                        Vertragswidrigkeit, insbesondere bei nur geringfügigen Mängeln, steht dem Kunden
                                        jedoch kein
                                        Rücktrittsrecht zu.</li>
                                    <li>Sofern ein Mangel nicht auf einer fahrlässigen oder vorsätzlichen
                                        Pflichtverletzung
                                        beruht, ist der Kunde nicht zum Rücktritt vom Vertrag berechtigt. </li>
                                    <li>Die im Falle einer Nacherfüllung entstehenden Kosten trägt die GSI. Zusätzliche
                                        Kosten,
                                        die dadurch entstehen, dass der Leistungsgegenstand oder das Erzeugnis an dem
                                        wir unsere
                                        Leistung erbracht haben an einen anderen Ort
                                        als den Sitz oder den vertraglich vereinbarten Erfüllungsort des Auftraggebers
                                        verbracht
                                        worden ist, trägt der Auftraggeber.
                                    </li>
                                    <li>Rechte des Auftraggebers wegen Mängeln, die nicht ein Bauwerk bzw. ein Werk, das
                                        in der
                                        Erbringung von Planungs- und Überwachungsleistungen hierfür besteht, betreffen,
                                        verjähren in
                                        einem Jahr ab Abnahme des Werkes. Diese
                                        kurze Verjährungsfrist gilt nicht, wenn uns grobes Verschulden vorwerfbar ist,
                                        sowie im
                                        Falle von uns zurechenbaren Körper und Gesundheitsschäden oder bei Verlust des
                                        Lebens. Die
                                        Haftung nach dem Produkthaftungsgesetz bleibt
                                        ebenfalls unberührt.</li>
                                    <li>Bei arglistigem Verschweigen von Mängeln oder der Übernahme einer Garantie für
                                        die
                                        Beschaffenheit bleiben weitergehende Ansprüche unberührt.
                                    </li>
                                    <li>Eine Gewährleistung oder Schadensersatz (gemäß Ziffer 8 AGB) für die
                                        Realisierung von
                                        Schätzungen oder Prognosen übernehmen wir nur, sofern dies ausdrücklich
                                        vereinbart wurde.</li>
                                </ul>
                            </li>
                            <li class="font-weight-bold mt-2">Haftung/ Schadensersatz
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Die Haftung der GSI wegen Verzögerungen oder Unmöglichkeit werden von diesem
                                        Abschnitt
                                        (Ziffer 8) nicht erfasst. Für diese Haftung gelten die Regelungen der Ziffer 4.4
                                        dieser
                                        AGB.</li>
                                    <li>Schadensersatzansprüche gegenüber der GSI sind grundsätzlich ausgeschlossen.
                                        Dies gilt
                                        nicht bei Vorliegen grob fahrlässiger Pflichtverletzungen oder bei Vorsatz
                                        und/oder bei
                                        einer zu vertretenden Verletzung wesentlicher
                                        Vertragspflichten. Wesentliche sind die Vertragspflichten, deren Erfüllung die
                                        ordnungsgemäße Durchführung des Vertrages überhaupt erst ermöglicht und auf
                                        deren Einhaltung
                                        der Vertragspartner regelmäßig vertraut und vertrauen
                                        darf. Der Ausschluss oder die Beschränkung unser Haftung gilt ebenfalls nicht,
                                        bei der
                                        Verletzung von Leben, Körper, Gesundheit von Personen oder soweit wir nach dem
                                        Produkthaftungsgesetz zwingend haften.</li>
                                    <li>Kann die GSI bei Verletzung wesentlicher Vertragspflichten wegen einfacher
                                        Fahrlässigkeit zur Zahlung von Schadensersatz in Anspruch genommen werden, ist
                                        unsere
                                        Haftung auf die Höhe unserer Haftpflichtversicherung in Höhe
                                        von Euro 10.000.000,00 (in Worten Zehnmillionen) beschränkt. Sollte
                                        ausnahmsweise diese
                                        Schadensdeckungssumme dem typischerweise voraussehbaren Schaden nicht
                                        entsprechen, so ist
                                        unsere Haftung jedenfalls der Höhe nach auf den
                                        typischen voraussehbaren Schaden beschränkt.</li>
                                    <li>Eine Haftung auf Schadensersatz für die Freiheit von Rechten Dritter wird nicht
                                        übernommen, soweit nicht eine vorsätzliche oder grob fahrlässige
                                        Pflichtverletzung der GSI
                                        und/ oder ihrer Erfüllungs- und
                                        Verrichtungsgehilfen vorliegt. Kann das Ergebnis durch vorhandene störende
                                        Schutzrechte ganz
                                        oder teilweise nicht genutzt werden, werden wir dem Auftraggeber nach Bekannt
                                        werden
                                        geeignete Vorschläge zur Klärung der Rechtslage
                                        sowie des gemeinsamen Vorgehens gegen einen Dritten mit dem Ziel der Beseitigung
                                        des Mangels
                                        unterbreiten.</li>
                                    <li>Soweit die Haftung nach den Bestimmungen gemäß Ziffer 8 ausgeschlossen oder
                                        begrenzt
                                        ist, gilt dies auch für die persönliche Haftung der Organe der GSI, ihrer
                                        Angestellten,
                                        Arbeitnehmer, Mitarbeiter, Vertreter,
                                        Auftragnehmer und Unterauftragnehmer.</li>
                                </ul>
                            </li>
                            <li class="font-weight-bold mt-2">Schutz-, Urheber-, und Nutzungsrecht
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Entstehen bei der Bearbeitung der vertragsgemäßen Leistung durch uns
                                        schutzwürdige
                                        Ergebnisse, stehen diese uns zu. Wir leiten deren schutzrechtliche Sicherung auf
                                        eigene
                                        Kosten ein.</li>
                                    <li>Benötigt der Kunde zur Nutzung unserer Leistungen lizenzierte oder lizenzfähiger
                                        Schutzrechte von uns oder schutzfähiges know how, so darf dieses nur nach
                                        Maßgabe eines
                                        gesondert mit uns abzuschließenden Patent-/know
                                        how-Lizenzvertrag gewerblich genutzt werden.</li>
                                    <li>Wir erhalten ein kostenloses, nichtausschließliches Nutzungsrecht an allen
                                        während der
                                        Vertragsbearbeitung hervorgebrachten Urheber- und/oder Schutzrechten, an denen
                                        der
                                        Auftraggeber als Miturheber beteiligt ist. Wir
                                        können diese ungehindert bei der Bearbeitung weiterer Aufträge Dritter
                                        einsetzen.</li>
                                    <li>Die Weitergabe und Verwertung unserer Leistung über den vertraglich festgelegten
                                        Zweck
                                        hinaus, insbesondere deren Veröffentlichung, ist nur mit unserer vorherigen
                                        schriftlichen
                                        Zustimmung zulässig. Für die Einhaltung der
                                        für die Verwertung unserer Leistung geltenden gesetzlichen Bestimmungen (u. a.
                                        des
                                        Wettbewerbsrechts), insbesondere für den Inhalt von Werbeaussagen, ist
                                        ausschließlich der
                                        Kunde verantwortlich; er hat uns insoweit von
                                        sämtlichen Ansprüchen Dritter freizuhalten.</li>

                                </ul>
                            </li>


                            <li class="font-weight-bold mt-2">Geheimhaltung
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Auftraggeber und wir verpflichten uns, alle in Realisierung des Vertrages
                                        erhaltenen
                                        mündlichen und schriftlichen Informationen und Mitteilungen gegenüber Dritten
                                        geheimzuhalten, solange nicht diese Information auf
                                        andere Weise allgemein bekannt geworden ist oder die Partner schriftlich auf
                                        ihre
                                        Geheimhaltung verzichtet haben. Nicht als unbefugte Dritte gelten Personen,
                                        Einrichtungen u.
                                        a. dann, wenn die Weitergabe der Informationen an
                                        diesen Personenkreis der Erreichung des Vertragszweckes durch uns förderlich
                                        ist.</li>


                                </ul>
                            </li>
                            <li class="font-weight-bold mt-2">Kündigung
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Bei Vorliegen eines wichtigen Grundes sind wir berechtigt, das
                                        Vertragsverhältnis
                                        fristlos zu kündigen.</li>
                                    <li>Als wichtige Kündigungsgründe für uns gelten insbesondere:<br />- nicht oder
                                        nicht
                                        fristgemäße Zahlung von Vorschüssen oder Nichteinhaltung vereinbarter
                                        Zahlungstermine durch
                                        den Auftraggeber.<br />- Annahmeverzug des
                                        Auftraggebers.</li>
                                    <li>Nach wirksamer Kündigung übergeben wir dem Auftraggeber das bis zur Kündigung
                                        erreichte Ergebnis, in einer dann zu vereinbarenden Frist. Der Auftraggeber ist
                                        verpflichtet, an uns die bis dahin entstandenen Teilleistungen
                                        und Auslagen zu vergüten. Im Übrigen gilt § 649 BGB, es sei denn, wir hätten die
                                        Kündigung
                                        verschuldet.</li>

                                    <li>Jeder Partner ist dann verpflichtet, dem anderen Partner zum Zwecke der
                                        Vertragserfüllung vorübergehend zur Verfügung gestellte Sachen und Rechte
                                        unverzüglich
                                        zurückzugeben. Das betrifft auch die Rückzahlung an uns
                                        voraus gezahlter Geldbeträge, soweit diese die bis dahin entstandenen oder
                                        anteiligen
                                        Vergütungsansprüche übersteigen.</li>
                                    <li>Weitere Ansprüche des Auftraggebers bestehen nicht.</li>



                                </ul>
                            </li>
                            <li class="font-weight-bold mt-2">Erfüllungsort und Abtretungsverbot
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Erfüllungsort für alle Leistungen ist nach Wahl der GSI Düsseldorf bzw. der Sitz
                                        der
                                        ausführenden Niederlassung.</li>
                                    <li>Die Abtretung von Ansprüchen, die dem Kunden aus der Geschäftsverbindung mit uns
                                        zustehen, ist ausgeschlossen.</li>
                                </ul>
                            </li>
                            <li class="font-weight-bold mt-2">Gerichtsstand und anwendbares Recht
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Gerichtsstand für alle aus der Geschäftsverbindung herrührenden Ansprüche
                                        gegenüber
                                        Kaufleuten und juristischen Personen des öffentlichen Rechts oder einem
                                        öffentlich
                                        rechtlichem Sondervermögen ist nach Wahl der GSI
                                        Düsseldorf oder der Sitz der ausführenden Niederlassung. Dies gilt auch für
                                        Ansprüche aus
                                        Schecks sowie für deliktsrechtliche Ansprüche und Streitverkündungen. Wir sind
                                        jedoch auch
                                        berechtigt, den Kunden an seinem allgemeinen
                                        Gerichtsstand zu verklagen.</li>
                                    <li>Bei grenzüberschreitenden Leistungen ist Düsseldorf ausschließlicher
                                        Gerichtsstand für
                                        alle Streitigkeiten aus dem Vertragsverhältnis. Wir behalten uns jedoch das
                                        Recht vor, den
                                        Kunden an seinem allgemeinen Gerichtsstand
                                        zu verklagen oder jedes andere zuständige Gericht anzurufen.</li>
                                    <li>Für alle Geschäfts- und die gesamten Rechtsbeziehungen zwischen dem Kunden und
                                        uns
                                        gilt ausschließlich das Recht der Bundesrepublik Deutschland.</li>
                                </ul>
                            </li>

                            <li class="font-weight-bold mt-2">Schlussbestimmungen
                                <ul class="font-weight-normal  mt-2" style="list-style:decimal">
                                    <li>Sollten einzelne der vorstehenden Bedingungen unwirksam sein oder werden, so
                                        berührt
                                        dies nicht die Wirksamkeit der übrigen Bestimmungen. Anstelle der unwirksamen
                                        Bedingungen
                                        sollen solche Regelungen treten, die dem
                                        wirtschaftlichen Zweck des Vertrages und der angemessenen Wahrung der
                                        beiderseitigen
                                        Interessen am nächsten kommen.</li>
                                    <li>Alle unsere früheren Allgemeinen Geschäftsbedingungen für Leistungen der GSI
                                        werden
                                        durch diese AGB ersetzt. Diese AGB gelten für alle Leistungen der GSI ab dem
                                        Stand dieser
                                        AGB.</li>

                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<style lang="scss" scoped>
    @import 'resources/sass/_variables.scss';


</style>

<script>
    export default {
        mounted() {

        }
    }

</script>
